import { QueryClientProvider } from "@tanstack/react-query";
import React, { FC } from "react";
import { queryClient } from "./queryClient";

// Minimal prop type for the devtools component. We can't import DevtoolsOptions
// from "@tanstack/react-query-devtools/build/lib/devtools" because the package's
// `exports` map doesn't expose that subpath. Defining locally avoids depending on
// private internal paths that may break on patch upgrades.
type ReactQueryDevToolsProps = {
  initialIsOpen?: boolean;
} & Record<string, unknown>;

const ReactQueryDevtoolsDev = React.lazy(() =>
  import("@tanstack/react-query-devtools").then((d) => ({
    default: d.ReactQueryDevtools,
  })),
);

const ReactQueryDevtoolsProd = React.lazy(() =>
  import("@tanstack/react-query-devtools/build/lib/index.prod.js").then((d) => ({
    default: d.ReactQueryDevtools,
  })),
);

export const ReactQueryDevTools = ({ initialIsOpen = false, ...otherProps }: ReactQueryDevToolsProps) => {
  return (
    <React.Suspense fallback={null}>
      {Config.nodeEnv === "production" ? (
        <ReactQueryDevtoolsProd {...otherProps} initialIsOpen={initialIsOpen} position="bottom-right" />
      ) : (
        <ReactQueryDevtoolsDev {...otherProps} initialIsOpen={initialIsOpen} position="bottom-right" />
      )}
    </React.Suspense>
  );
};

export const ReactQueryProvider: FC<React.PropsWithChildren> = ({ children }: React.PropsWithChildren) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
